import React from 'react';
import { useIndiaSpecificPrivacyPolicy } from "../../Components/DataRetention/IndiaSpecificPrivacyPolicy";
import { getBrandName } from "../../Components/getBrandName";
import SEO from '../../../../SEO/Seo';
import { metaContent } from '../../../../SEO/metaContent';
const IndiaSpecificPrivacyPolicy = () => {
  const { sections, generateContent } = useIndiaSpecificPrivacyPolicy();
  const { brandName } = getBrandName();

  return (<>
    {/* Meta tags  */}
    <SEO {...metaContent.indiaSpecificPolicy} />

    <div className="privacy-policy-page">
      <div className="privacy-policy-heading text-center">
        <h2>India-Specific Privacy Policy</h2>
        <p className="text-muted" style={{ fontSize: "0.8rem" }}>How We Handle Your Data In Full Compliance with the DPDP Act, 2023</p>
        <p className="text-muted" style={{ fontSize: "0.8rem" }}>Effective Date: <strong>July 3, 2025</strong></p>
      </div>

      <div className="privacy-container">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <p>
                At {brandName}, your privacy is our priority. We collect, use, and manage your data responsibly, ethically, and lawfully. This India-specific privacy policy is framed to comply with the Digital Personal Data Protection Act (DPDP), 2023, ensuring that you are always in control of your data.
              </p>
              {sections.map((section) => (
                <div key={section.id} className="mb-5">
                  <h5 className="fw-bold">{section.title}</h5>
                  <div className="text-muted">
                    {generateContent(section.id)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default IndiaSpecificPrivacyPolicy;
